const isReadOnly = (requestStatus: string, hasApproverPermission: boolean) => {
  if (requestStatus === "APPROVED") {
    return true;
  }
  if (requestStatus === "REJECTED") {
    return true;
  }

  if (requestStatus === "SUBMITTED" && !hasApproverPermission) {
    return true;
  }

  return false;
};
export default isReadOnly;
